// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__BvWqL"};